import { styled } from '@mui/material/styles';

export const LogoWrapper = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 58px;

  img {
    max-width: 140px;
    max-height: 40px;
    object-fit: contain;
  }
`;